import { useEffect } from "react";
import Loader from "../Misc/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { checkLogin } from "../../service";
import { updateUser } from "../../redux/actions";

const MainPanel = ({ children }) => {
  const { loading } = useSelector((state) => state.misc);
  const location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      let userData = localStorage.getItem("userData");
      if (userData) {
        userData = JSON.parse(userData);
        dispatch(updateUser(userData));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }, []);

  useEffect(() => {
    checkLogin();
  }, [location.pathname]);

  return (
    <div className="rounded-sm border shadow-default border-strokedark bg-boxdark p-4 h-full">
      {loading && <Loader />}
      {children}
    </div>
  );
};

export default MainPanel;
